
import { createContext, useContext } from 'react'

import { DialogComponentProps, DialogType } from './models/DialogStructure'

export type DialogContextType = {
  dialogs: DialogType[]
  openDialog: (Component: React.ComponentType<DialogComponentProps>, props: Omit<DialogComponentProps, 'open'>) => void
  closeDialog: () => void
  closeAllDialogs: () => void
}

export const DialogContext = createContext<DialogContextType>({
  dialogs: [],
  openDialog: (_Component: React.ComponentType<DialogComponentProps>, _props: Omit<DialogComponentProps, 'open'>) => { },
  closeDialog: () => { },
  closeAllDialogs: () => { },
})


// Export the hook that components can use to access the dialog context
export const useDialogContext = (): DialogContextType => {
  const context = useContext(DialogContext)

  if (!context) {
    throw new Error('useDialog must be used within a DialogContext.Provider')
  }

  return context
}


export const useDialog = () => useContext(DialogContext)
